/* Rillwerk PDP. Hero = self-playing muted loop (poster fallback). html.static (?static=1 or reduced motion) = still, no motion. */
(function () {
  'use strict';
  var MOTION = !(/[?&]static=1/.test(location.search) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches));
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var toast = $('.toast'), tt;
  function say(msg) { toast.textContent = msg; toast.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('show'); }, 2600); }

  /* hero loop */
  var vid = $('.loop-vid');
  if (MOTION && vid) {
    var base = vid.getAttribute(window.matchMedia('(max-width:600px)').matches ? 'data-m' : 'data-d'), inView = true;
    var play = function () { var p = vid.play(); if (p && p.catch) p.catch(function () {}); };
    vid.addEventListener('playing', function () { vid.classList.add('on'); }, { once: true });
    var start = function () { vid.src = base; vid.muted = true; if (inView) play(); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; if (!vid.getAttribute('src')) return; if (inView) play(); else vid.pause(); }).observe(vid.parentNode);
    }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }

  /* gallery: thumbs + set images crossfade */
  var front = $('[data-og]'), back = $('[data-og2]'), count = $('[data-ogc]');
  function showImg(src, alt) {
    if (front.getAttribute('src') === src) return;
    front.removeAttribute('srcset');
    back.onload = function () { back.onload = null; back.style.opacity = 1; front.style.opacity = 0; back.alt = alt || ''; back.removeAttribute('aria-hidden'); front.alt = ''; front.setAttribute('aria-hidden', 'true'); var t = front; front = back; back = t; };
    back.src = src;
  }
  var thumbs = $$('.og-thumbs .tb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { thumbs.forEach(function (x) { x.classList.toggle('on', x === t); }); showImg(t.getAttribute('data-full'), t.querySelector('img').alt); });
  });

  var RW_TRACK = (function () {
    var k = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'cmc_vid', 'cmc_adid'], q = new URLSearchParams(location.search), t = {};
    try { t = JSON.parse(sessionStorage.getItem('rw_track') || '{}'); } catch (e) {}
    k.forEach(function (n) { var v = q.get(n); if (v) t[n] = v.slice(0, 250); });
    try { sessionStorage.setItem('rw_track', JSON.stringify(t)); } catch (e) {}
    return t;
  })();
  function cartUrl(set) {
    var v = (window.RW_VARIANTS || {})[set]; if (!v) return '#buy';
    var u = new URLSearchParams(), cm = window.clickmagick_cmc; u.set('attributes[ad_landing_page]', 'rillwerk-us');
    Object.keys(RW_TRACK).forEach(function (n) { u.set('attributes[ad_' + n + ']', RW_TRACK[n]); });
    if (cm && cm.vid) u.set('attributes[ad_cm_visitor]', cm.vid);
    return (window.RW_CART || '/cart') + '/' + v + ':1?' + u.toString();
  }
  /* sets: one price per set */
  var sets = $$('.bd'), cur = sets[0];
  function money(e) { return '$' + e; }
  function setSet(b) {
    cur = b; var p = +b.getAttribute('data-price'), n = b.getAttribute('data-name');
    sets.forEach(function (x) { var on = x === b; x.classList.toggle('sel', on); x.querySelector('input').checked = on; });
    $('[data-setname]').textContent = n; $('[data-total]').textContent = money(p);
    $('[data-buy]').textContent = 'Add to cart – ' + money(p);
    $('[data-bb-label]').textContent = n; $('[data-bb-price]').textContent = money(p);
    count.textContent = b.getAttribute('data-count');
    thumbs.forEach(function (t) { t.classList.remove('on'); });
    showImg(b.getAttribute('data-img'), n);
  }
  sets.forEach(function (b) { b.querySelector('input').addEventListener('change', function () { setSet(b); }); });
  $('[data-buy]').addEventListener('click', function (e) { e.preventDefault(); location.href = cartUrl(cur.getAttribute('data-set')); });

  /* sticky buy bar (mobile) */
  var bar = $('[data-buybar]'), plan = $('#buy'), heroEl = $('.hero');
  function barCheck() {
    var y = window.scrollY, h = heroEl.getBoundingClientRect(), p = plan.getBoundingClientRect();
    bar.classList.toggle('show', h.bottom < 0 && !(p.top < window.innerHeight * 0.85 && p.bottom > 0) && document.documentElement.scrollHeight - y - window.innerHeight > 200);
  }
  window.addEventListener('scroll', barCheck, { passive: true }); barCheck();
})();
